import Email from './index';

export default { path: '/home/email', component: Email };
